import React from 'react'
import { Box, Typography, Paper } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface AdSensePlaceholderProps {
    width?: number
    height?: number
    variant?: 'banner' | 'rectangle' | 'square' | 'skyscraper'
    position?: 'top' | 'side' | 'bottom'
}

const AdSensePlaceholder: React.FC<AdSensePlaceholderProps> = ({
    width = 728,
    height = 90,
    variant = 'banner',
    position = 'top'
}) => {
    const theme = useTheme()

    const getDimensions = () => {
        switch (variant) {
            case 'banner':
                return { width: 728, height: 90 }
            case 'rectangle':
                return { width: 300, height: 250 }
            case 'square':
                return { width: 250, height: 250 }
            case 'skyscraper':
                return { width: 160, height: 600 }
            default:
                return { width, height }
        }
    }

    const { width: adWidth, height: adHeight } = getDimensions()

    return (
        <Paper
            elevation={1}
            sx={{
                width: adWidth,
                height: adHeight,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100',
                border: `2px dashed ${theme.palette.mode === 'dark' ? 'grey.600' : 'grey.400'}`,
                borderRadius: 2,
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' ? 'grey.700' : 'grey.200',
                }
            }}
        >
            <Box sx={{ textAlign: 'center', p: 2 }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.mode === 'dark' ? 'grey.400' : 'grey.600',
                        fontSize: '0.75rem',
                        fontWeight: 500
                    }}
                >
                    Google AdSense
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.mode === 'dark' ? 'grey.500' : 'grey.500',
                        fontSize: '0.7rem',
                        display: 'block',
                        mt: 0.5
                    }}
                >
                    {adWidth} × {adHeight}
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.mode === 'dark' ? 'grey.500' : 'grey.500',
                        fontSize: '0.65rem',
                        display: 'block',
                        mt: 0.5
                    }}
                >
                    {position} • {variant}
                </Typography>
            </Box>
        </Paper>
    )
}

export default AdSensePlaceholder
